import Text from '@ingka/text';
import Button from '@ingka/button';
import { PREFIX } from '../Skapa/constants/constants';
import styles from './CiamLoginModalContent.module.scss';
import { ButtonType } from '../Skapa/Button/Button';
import { useTranslation } from 'react-i18next';
import { getAuthServiceUrl, toUrl } from '../../utils/url';
import { useMemo } from 'react';
import { getRetailUnitAndLanguage } from '../../network/utils/getRetailUnitAndLanguage';

export function CiamLoginModalContent() {
  const { t } = useTranslation('profile');

  const login = useMemo(() => {
    const { retailUnit, language: lang } = getRetailUnitAndLanguage();

    return toUrl(`${getAuthServiceUrl()}/login`, {
      lang,
      retailUnit,
      referrer: globalThis.location.href,
    });
  }, []);

  const signup = useMemo(() => {
    const { retailUnit, language: lang } = getRetailUnitAndLanguage();

    return toUrl(`${getAuthServiceUrl()}/signup`, {
      lang,
      retailUnit,
      referrer: globalThis.location.href,
    });
  }, []);

  return (
    <div>
      <Text
        prefix={PREFIX}
        tagName="h2"
        textStyle="Heading.L"
        className={styles.header}
        data-testid="login-sheet-header"
      >
        {t('loginPrompt.alternativeOption.header')}
      </Text>
      <Text prefix={PREFIX} tagName="p">
        {t('loginPage.loginPageHeaderDescription')}
      </Text>
      <Button
        className={styles.button}
        prefix={PREFIX}
        fluid
        href={login}
        data-testid="login"
        text={t('loginPage.loginButton')}
        type={ButtonType.PRIMARY}
      />
      <div className={styles.divider}>
        <Text prefix={PREFIX} tagName="span">
          {t('loginPrompt.newIkea.text')}
        </Text>
      </div>
      <Button
        className={styles.button}
        prefix={PREFIX}
        fluid
        href={signup}
        data-testid="create-account"
        text={t('loginPage.createAccountButton')}
        type={ButtonType.SECONDARY}
      />
    </div>
  );
}
